import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { Order, Timeframe, Venue } from "../models";
import { OrderApi } from "../api/order.api";
import { Observable, Subscription } from "rxjs";
import { DateService } from "./date.service";
import { AnalyticsService } from "./analytics.service";
import { OrderFilterService } from "./filter.service";
import * as firebase from "firebase";
@Injectable({
  providedIn: "root"
})
export class OrderService {
  private api: OrderApi;
  private date: DateService;
  // public analytics: AnalyticsService;

  public orders$: Observable<Order[]>;
  public subscription: Subscription;

  public orders: Order[];
  public filter: OrderFilterService;

  constructor(public db: AngularFirestore, public venue?: Venue) {
    this.initializeLocalVariables();
    this.observe();
    this.subscribe(); 
  }

  initializeLocalVariables() {
    this.api = new OrderApi(
      "devOrders",
      this.db,
      this.venue ? this.venue.name : ""
    );
    this.date = new DateService();
    this.orders = [];
  }

  /** BEGIN LISTENER FUNCTIONS */
  observe = (tf?: Timeframe) => {
    if (this.venue == null)
      this.orders$ = this.api.getAll(tf ? tf : this.date.monthToDate);
    else
      this.orders$ = this.api.getVenueOrders(tf ? tf : this.date.monthToDate);
  };

  subscribe(changedTimeframe?: boolean) {
    this.subscription = this.orders$.subscribe(async orders => {
      this.orders = orders;
      if (this.filter == null) this.filter = new OrderFilterService(orders);
      else this.filter.update(orders);
      if (changedTimeframe) {
        this.filter.filtered = orders;
        this.filter.filter();
      }
    });
  }

  /** END LISTENER FUNCTIONS */

  /** BEGIN FILTER FUNCTIONALITY */

  changeTimeframe(key: string, timeframe: Timeframe) {
    this.filter.currentTimeframe = key;
    this.filter.resetPaginator();
    this.getOrders(true, timeframe);
  }

  async getOrders(changedTimeframe?: boolean, timeframe?: Timeframe) {
    this.subscription.unsubscribe();
    this.observe(timeframe);
    this.subscribe(changedTimeframe);
  }
  async redeem(order: Order) {
    order.items[0].summary.redeemedAt = firebase.firestore.Timestamp.now();
    await this.db
      .collection("devOrders")
      .doc(order.id)
      .update(order);
  }
  async unredeem(order: Order) {
    order.items[0].summary.redeemedAt = null;
    await this.db
      .collection("devOrders")
      .doc(order.id)
      .update(order);
  }
}
